import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buzztimeprobook/frontend/layouts/default.vue").then(m => m.default || m))
}